export default {
  percent: '%',
  px: 'px',
  angle: '\xB0',
  seconds: 's',
  spx: 'px*'
};